import React from 'react';
import Slider from 'react-slick';
import {Button} from '../../components';

const HeroOne = ()=> {   

  const HEROCONTENT = [
    {
      image: 'images/hero/cbt.jpg',
      title: <>BWay<span className="hero-innertext">Computer Based Testing Platform</span> <br/> LEARNING MANAGEMENT SYSTEM</>,
      text: 'Empowering education through technology, BWay is dedicated to providing innovative IT solutions that enhance learning experiences and drive academic success.',
      btn1: {text: 'About Us', path: '/about'},
      btn2: {text: 'READ MORE',path: '/about'}
    },
   
  ];
  
  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          arrows: false,
        }
      }
    ]
  };
  
  
  return (
    <Slider className="hero-layout1" {...settings}>
      {HEROCONTENT.map((slide, index) => (
        <div key={index}>
          <div className="hero-inner">
            <div className="hero-shape1"></div>
            <div className="hero-shape2"></div>
            {/* <div className="hero-bg background-image" style={{backgroundImage: `url(${slide.image})`}}></div> */}

            <div className="hero-bg-wrapper">
            <div className="hero-bg background-image" style={{backgroundImage: `url(${slide.image})`}}></div>
              <div className="black-overlay"></div>
            </div>
            <div className="container">
              <div className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-text">{slide.text}</p>
                <div className="hero-btns">
                  <Button path={slide.btn1.path}>{slide.btn1.text}<i className="far fa-arrow-right"/></Button>
                  <Button path={slide.btn2.path} className="style2">{slide.btn2.text}<i className="far fa-arrow-right"/></Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}    
    </Slider>
  );
}

export default HeroOne; 